module.exports = __webpack_public_path__ + "static/media/Duplicate File.5c44cc82.svg";